import React, { useState } from "react";
import Popup from "./PopupWithMessage";
import PhoneInput from "./../PhoneInput/PhoneInput";
import SelectInput from "../SelectInput/SelectInput";

const SendButton = ({ onClick }) => (
  <button type="submit" disabled className="button popup-footer__button">Отправить</button>
);

const ServiceReviewPopup = ({ name, authenticity_token, serviceId, doctors }) => {
  const [messageShown, setMessageShown] = useState(false);
  const hideMessage = () => {
    setMessageShown(false);
  };

  const handleSubmit = e => {
    e.preventDefault();
    const data = new FormData(e.target);
    const dataIterator = Array.from(data);

    const postObject = dataIterator.reduce((obj, [key, value]) => {
      return {
        ...obj,
        [key]: value
      };
    }, {});
    const axios = require('axios');
    const url = '/reviews'

    axios.post(url, {
       'utf8': postObject.utf8,
       'authenticity_token': postObject.authenticity_token,
       'reviewable_id': postObject.reviewable_id,
       'reviewable_type': postObject.reviewable_type,
       'physician': postObject.physician,
       'fullname': postObject.fullname,
       'email': postObject.email,
       'phone': postObject.phone,
       'body': postObject.body,
       'agreed': postObject.agreed
    })
    .then(function (response) {
      console.log('Ok');
    })
    .catch(function (error) {
      console.log(error);
    })
    .then(function () {
      // always executed
    });
    setMessageShown(true);
  };

  const changeAgree = e => {
    const btn = document.querySelector('.popup-footer__button');

    if (btn.disabled == true) {
      btn.disabled = false;
    } else {
      btn.disabled = true;
    };
  };

  return (
    <form onSubmit={handleSubmit} className="new_review" id="new_review" action="/reviews" acceptCharset="UTF-8" method="post">
      <input name="utf8" type="hidden" value="✓" />
      <input type='hidden' name='authenticity_token' value={authenticity_token} />
      <input value={serviceId} type="hidden" name="reviewable_id" id="review_reviewable_id" />
      <input value="Service" type="hidden" name="reviewable_type" id="review_reviewable_type" />
      <Popup
        name={name}
        onHide={hideMessage}
        header="Оставьте свой отзыв о враче"
        footer={
          <SendButton />
        }
        message="Спасибо за отзыв!"
        messageShown={messageShown}
        hideMessage={hideMessage}
      >
        <div className="popup-form">
          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" name='fullname'>Ваше имя</label>
            <input className="input-group__input" required name='fullname' />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" name='email'>Электронная почта</label>
            <input className="input-group__input" required name='email' type="email" />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" name='phone'>Телефон</label>
            <PhoneInput name={'phone'}/>
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" name='physician'>Специалист</label>
            <SelectInput options={doctors} />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" name='body'>Отзыв</label>
            <textarea className="input-group__textarea" required name='body' />
          </div>

          <div className="input-group">
            <label className="input-group__label input-group__label_checkbox">
              <input type="checkbox" onClick={changeAgree} className="input-group__checkbox" required name='agreed' />
              <div className="input-group__checkbox-state" />
              Выражаю согласие на обработку персональных данных в соответствии
              с условиями.
            </label>
          </div>
        </div>
      </Popup>
    </form>
  );
};

export default ServiceReviewPopup;
